/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlUseCase } from './ControlUseCase';
import {
    ControlUseCaseFromJSON,
    ControlUseCaseFromJSONTyped,
    ControlUseCaseToJSON,
} from './ControlUseCase';

/**
 * 
 * @export
 * @interface ControlIntegrationActionV2
 */
export interface ControlIntegrationActionV2 {
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationActionV2
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationActionV2
     */
    display: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationActionV2
     */
    showWebhookSecret?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationActionV2
     */
    slug: string;
    /**
     * 
     * @type {Array<ControlUseCase>}
     * @memberof ControlIntegrationActionV2
     */
    useCases: Array<ControlUseCase>;
}

/**
 * Check if a given object implements the ControlIntegrationActionV2 interface.
 */
export function instanceOfControlIntegrationActionV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "display" in value;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "useCases" in value;

    return isInstance;
}

export function ControlIntegrationActionV2FromJSON(json: any): ControlIntegrationActionV2 {
    return ControlIntegrationActionV2FromJSONTyped(json, false);
}

export function ControlIntegrationActionV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlIntegrationActionV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': json['description'],
        'display': json['display'],
        'showWebhookSecret': !exists(json, 'showWebhookSecret') ? undefined : json['showWebhookSecret'],
        'slug': json['slug'],
        'useCases': ((json['useCases'] as Array<any>).map(ControlUseCaseFromJSON)),
    };
}

export function ControlIntegrationActionV2ToJSON(value?: ControlIntegrationActionV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'display': value.display,
        'showWebhookSecret': value.showWebhookSecret,
        'slug': value.slug,
        'useCases': ((value.useCases as Array<any>).map(ControlUseCaseToJSON)),
    };
}

